"use client";
import React, { useRef } from "react";
import { useScroll, useTransform, motion } from "framer-motion";
import "./style.css";

export const ContainerScroll = ({ titleComponent, children }) => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
  });
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  const scaleDimensions = () => {
    return isMobile ? [0.7, 0.9] : [1.05, 1];
  };

  const rotate = useTransform(scrollYProgress, [0, 1], [20, 0]);
  const scale = useTransform(scrollYProgress, [0, 1], scaleDimensions());
  const translate = useTransform(scrollYProgress, [0, 1], [0, -100]);

  return (
    <div
      className="h-[35rem] flex items-center justify-center relative p-4 md:p-6 mb-[-100px] md:mb-[-70px]"
      ref={containerRef}
    >
      <div
        className="py-1 md:py-0 w-full relative"
        style={{
          perspective: "1000px",
        }}
      >
        <Header translate={translate} titleComponent={titleComponent} />
        <Card rotate={rotate} translate={translate} scale={scale}>
          {children}
        </Card>
      </div>
    </div>
  );
};

export const Header = ({ translate, titleComponent }) => {
  return (
    <motion.div
      style={{
        translateY: translate,
      }}
      className="div max-w-5xl mx-auto text-center"
    >
      {titleComponent}
    </motion.div>
  );
};

export const Card = ({ rotate, scale, children }) => {
  return (
    <motion.div
      style={{
        rotateX: rotate,
        scale,
        marginTop: "-10rem",
      }}
      className="syl-retreat max-w-3xl -mt-2 mx-auto h-[15rem] md:h-[22rem] sm:h-[400px] w-full border-4 border-[#ffffff] p-2 md:p-6 bg-[#222222] rounded-[30px]"
    >
      <div className=" h-full w-full overflow-hidden rounded-2xl bg-white  md:rounded-2xl md:p-4 ">
        {children}
      </div>
    </motion.div>
  );
};
